export default __webpack_public_path__ + "static/media/BOOK 56698 - Máq. 16ton curto.d93e7481.pdf";